import React, { createContext, useCallback, useContext, useRef, useState } from 'react';

interface NoticeCtx {
  notify: (msg: string) => void;
}

const Ctx = createContext<NoticeCtx>({ notify: () => {} });

export function NoticeProvider({ children }: { children: React.ReactNode }) {
  const [msg, setMsg] = useState<string | null>(null);
  const timer = useRef<number | undefined>(undefined);

  const notify = useCallback((m: string) => {
    setMsg(m);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setMsg(null), 3200);
  }, []);

  return (
    <Ctx.Provider value={{ notify }}>
      {children}
      <div className={`ek-notice ${msg ? 'is-on' : ''}`} role="status" aria-live="polite" data-testid="notice-toast">
        {msg}
      </div>
    </Ctx.Provider>
  );
}

export const useNotice = () => useContext(Ctx);
